<template>
    <Navigation
        class="d-flex"
        :navigationItemList="widgetList"
        :data="data"
        @selectNavigationItem="goToWidget"
        @selectNavigationItemMenu="goToSelectedItem"
    />
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapGetters } from 'vuex';

    import Navigation from '@/layout/alternative/layout/components/Navigation.vue';

    export default {
        name: "ProgramBody",
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        components: {
            Navigation,
        },
        computed: {
            ...mapGetters([
                'startedWidget'
            ]),
            widgetList() {
                return this.$props.data ? this.$props.data.levels || this.$props.data.widgetList : {};
            },
        },
        methods: {
            goToWidget(widget) {
                let hasActiveHotspot = false;
                if (widget.active)
                    if (widget.hotspots) {
                        let activeHotspot = widget.hotspots.filter(hotspot => hotspot.active);
                        if (activeHotspot.length) {
                            hasActiveHotspot = true;
                        }
                    }
                if ((!hasActiveHotspot && !widget.active) || (hasActiveHotspot && widget.active)) {
                    this.startedWidget ==="program" ? EventBus.$emit('program_SetActive', widget) :  EventBus.$emit('generalView_SetActive', widget); 
                }
            },
            goToSelectedItem(item, subItem) {
                if (item.widgetType && item.widgetType === "configurable-tour")
                    this.goToConfigurableTour(item, subItem);
                else
                    this.goToHotspot(item, subItem);
            },
            goToHotspot(widget, hotspot) {
                EventBus.$emit("hotspot_setActive", widget, hotspot);
            },
            goToConfigurableTour(widget, configurableTour) {
                EventBus.$emit('configurableTour_setActive', widget, configurableTour);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/layout/alternative/program/ProgramBody.vue